import Vue from "vue";

const state = {
  users: [],
  totalUsers: 0
};
const getters = {};

const actions = {
  GET_USERS: function({ commit, rootState }, payload) {
    Vue.prototype.$axios
      .get(
        "/surgeries/" +
          rootState.auth.user.usurgery +
          "/users?from=" +
          payload.from +
          "&limit=" +
          payload.to
      )
      .then(res => {
        commit("SET_USERS", res.data.users);
        commit("SET_TOTAL_USERS", res.data.meta.total);
      });
  }
};

const mutations = {
  SET_USERS: function(state, payload) {
    state.users = payload;
  },
  SET_TOTAL_USERS: function(state, payload) {
    state.totalUsers = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
